export default {
  FixedPriceItem: {
    id: 'FixedPriceItem',
    humanReadableName: 'Fixed Price'
  },
  Chinese: {
    id: 'Chinese',
    humanReadableName: 'Auction'
  }
}
